import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Opens a page's create dialog when the URL says `?new=1`, which is how the
 * command palette reaches dialogs that have no route of their own. The param is
 * removed right away, so refreshing or going back does not open it again.
 */
export function useOpenFromQuery(open: (value: true) => void, param = 'new'): void {
  const [searchParams, setSearchParams] = useSearchParams()
  const requested = searchParams.get(param) === '1'

  useEffect(() => {
    if (!requested) return
    open(true)
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current)
        next.delete(param)
        return next
      },
      { replace: true }
    )
  }, [requested, open, param, setSearchParams])
}
